import "./WorkCard.css";

import React from "react";
import pro1 from "../assets/Screenshot (56).png";
import pro2 from "../assets/Screenshot (57).png";
import pro3 from "../assets/Screenshot (58).png";
import { NavLink } from "react-router-dom";
const Work = () => {
  return (
    <>
    <div className="work">
      <h1 className="project-heading">Projects</h1>
      <div className="project-container">
        <div className="project-card">
          <img src={pro1} alt="image" />
          <h2 className="project-title">Netflix Clone</h2>
          <div className="pro-details">
            <p>this is a paragraph about project 1</p>
            <div className="pro-btns">
              <NavLink to="https://tycoon-netflix.netlify.app/" className="btn">
                View
              </NavLink>
              <NavLink to="https://tycoon-netflix.netlify.app/" className="btn">
                Source
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
        <div className="work">
       
        <div className="project-container">
          <div className="project-card">
            <img src={pro2} alt="image" />
            <h2 className="project-title">Tycoonportfolio-website</h2>
            <div className="pro-details">
              <p>this is a paragraph about project 2</p>
              <div className="pro-btns">
                <NavLink to="https://tycoonportfolio-website.netlify.app/" className="btn">
                  View
                </NavLink>
                <NavLink to="https://tycoonportfolio-website.netlify.app/" className="btn">
                  Source
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="work">
      
      <div className="project-container">
        <div className="project-card">
          <img src={pro3} alt="image" />
          <h2 className="project-title">Tycoon-official</h2>
          <div className="pro-details">
            <p>this is a paragraph about project 3</p>
            <div className="pro-btns">
              <NavLink to="https://tycoon-official.netlify.app/" className="btn">
                View
              </NavLink>
              <NavLink to="https://tycoon-official.netlify.app/" className="btn">
                Source
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
      </>
  );
};

export default Work;
